<template>
    <on-escape :execute="close">
        <on-click-outside
            :is-active="is_open"
            :execute="close"
            :exclude="_.filter([
                menu,
                ...exclude
            ])"
        >
            <div
                ref="trigger"
                class="relative"
            >
                <slot
                    name="trigger"
                    :is-open="is_open"
                    :toggle="toggle"
                    :open="open"
                    :close="close"
                />

                <portal
                    v-if="is_open"
                    to="dropdowns"
                >
                    <div
                        ref="menu"
                        class="z-50"
                    >
                        <slot
                            name="menu"
                            :is-open="is_open"
                            :toggle="toggle"
                            :open="open"
                            :close="close"
                        />
                    </div>
                </portal>
            </div>
        </on-click-outside>
    </on-escape>
</template>

<script>
    import _ from 'lodash'
    import Popper from 'popper.js'

    window.currentlyOpen = {}

    export default {
        props: {
            placement: {
                type: String,
                default: 'bottom'
            },
            fill: {
                type: Boolean,
                default: false
            },
            exclude: {
                type: Array,
                default: () => []
            },
            closeOnRoute: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                uuid: _.uuid(),
                is_open: false,
                menu: null
            }
        },
        watch: {
            is_open () {
                this.$nextTick(() => {
                    this.menu = this.is_open ? this.$refs.menu : null
                })
            },
            '$route' () {
                if (this.closeOnRoute) this.close()
            }
        },
        beforeDestroy () {
            if (this.is_open) this.close()

            this.disablePopper()
        },
        methods: {
            toggle () {
                this.is_open ? this.close() : this.open()
            },
            open () {
                for (const key in window.currentlyOpen) {
                    if (Object.prototype.hasOwnProperty.call(window.currentlyOpen, key)) {
                        const component = window.currentlyOpen[key]

                        // don't check self
                        if (this.$el === component.$el) continue

                        // don't close dropdowns that contain other open dropdowns
                        // i.e. a select within a menu
                        if (component.$refs.menu.contains(this.$el)) continue

                        component.close()
                    }
                }

                window.currentlyOpen[this.uuid] = this

                setTimeout(() => {
                    this.is_open = true

                    this.$nextTick(() => {
                        this.enablePopper()

                        this.$emit('open')
                    })
                }, 0)
            },
            close (callback = null) {
                if (!this.is_open) {
                    this.$nextTick(() => {
                        this.disablePopper()
                    })

                    return
                }

                this.is_open = false

                setTimeout(() => {
                    this.$emit('close')

                    this.$nextTick(() => {
                        this.disablePopper()

                        delete window.currentlyOpen[this.uuid]

                        if (_.isFunction(callback)) {
                            callback()
                        }
                    })
                }, 0)
            },
            enablePopper () {
                this.popper = new Popper(this.$refs.trigger, this.$refs.menu, {
                    placement: this.placement,
                    modifiers: {
                        autoSizing: {
                            enabled: this.fill,
                            order: 840,
                            fn (data) {
                                data.offsets.popper.left = data.offsets.reference.left
                                data.offsets.popper.right = data.offsets.reference.right
                                data.offsets.popper.width = data.styles.width = Math.round(data.offsets.reference.width)
                                return data
                            }
                        }
                    }
                })
            },
            disablePopper () {
                if (this.popper) this.popper.destroy()
            }
        }
    }
</script>
